import type {Recipient} from 'src/types/contacts';

import _get from 'lodash/get';

import {getPrimaryPhone} from 'src/utils/contacts';


export function getRecipientPhone(recipient: Recipient): string {
  let recipientPhone;
  if (typeof recipient === 'string') {
    if (recipient.startsWith('0') && recipient.length > 10) {
      recipientPhone = recipient.slice(1);
    } else {
      recipientPhone = recipient;
    }
    // @ts-expect-error - TS2339 - Property 'atsContact' does not exist on type 'SuggestionType'.
  } else if (recipient.atsContact) {
    // @ts-expect-error - TS2339 - Property 'atsContact' does not exist on type 'SuggestionType'.
    recipientPhone = recipient.atsContact.phoneNumber;
    // @ts-expect-error - TS2339 - Property 'contact' does not exist on type 'SuggestionType'.
  } else if (recipient.contact) {
    // @ts-expect-error - TS2339 - Property 'contact' does not exist on type 'SuggestionType'.
    recipientPhone = getPrimaryPhone(recipient.contact);
    // @ts-expect-error - TS2339 - Property 'audienceMember' does not exist on type 'SuggestionType'.
  } else if (recipient.audienceMember) {
    // @ts-expect-error - TS2339 - Property 'audienceMember' does not exist on type 'SuggestionType'.
    recipientPhone = recipient.audienceMember.phoneNumber as string;
  }
  return recipientPhone;
}

export const getDraftKey = (props: {
  params: {
    phone?: string;
    scheduledMessageId?: string;
  };
}): string =>
  `${_get(props, 'params.phone', 'new')}${_get(
    props,
    'params.scheduledMessageId',
    '',
  )}`;
